module.exports = __webpack_public_path__ + "src/images/measurements/thighCircumference.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/thighCircumference.jpg
// module id = 1158
// module chunks = 0